import { setupEnvironment } from './actions';
import environmentReducer from './reducer';

export { setupEnvironment, environmentReducer };
